import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import RoteirizacaoPreviaRoutes from '../../routes/roteirizacao-previa.routes'
import { parseToMysqlFormat } from '../../../util/date.service'
import { urlAssocBadgeByData, urlAssocBadgeBySheet } from '../../routes/deliveries.routes'

export async function saveRoteirizacaoPrevia(roteirizacao) {
  try {
    const url = RoteirizacaoPreviaRoutes.urlSave
    const response = await authHttp().post(url, roteirizacao)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getRoteirizacoesPrevia(tp_id, periodoInicial, periodoFinal) {
  try {
    const pInicial = parseToMysqlFormat(periodoInicial)
    const pFinal = parseToMysqlFormat(periodoFinal)
    const url = RoteirizacaoPreviaRoutes.urlGetRoteirizacoesPorPeriodo(pInicial, pFinal, tp_id)
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function apagarRoteirizacoesPrevia(roteirizacao) {
  try {
    const url = RoteirizacaoPreviaRoutes.urlDeleteRoteirizacaoPrevia(roteirizacao.id)
    await authHttp().delete(url)
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function roteirizacaoGetEntregas(roteirizacao_id) {
  try {
    const url = RoteirizacaoPreviaRoutes.urlGetEntregas(roteirizacao_id)
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function roteirizacaoAssociarEntregas(roteirizacao_id, associacoes) {
  try {
    const url = RoteirizacaoPreviaRoutes.urlAssociarEntregas(roteirizacao_id)
    const response = await authHttp().put(url, associacoes)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function importarGradeContingencia(roteirizacao_id, fileContent, diaCross) {
  try {
    const url = RoteirizacaoPreviaRoutes.urlImportarGradeContingencia(roteirizacao_id, diaCross)
    const response = await authHttp().put(url, fileContent)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function importarPlacasPrevistaParaAssociar(typeOfSheet, data, roteirizacao_id) {
  try {
    const url = urlAssocBadgeBySheet(typeOfSheet, roteirizacao_id)
    const response = await authHttp().put(url, data)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function assocPlacasPrevistaComEntregas(roteirizacao_id, data) {
  try {
    const url = urlAssocBadgeByData(roteirizacao_id)
    const response = await authHttp().put(url, data)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
